<nav class="header-breadcrumb mb-2">
  <div *ngFor="let item of breadcrumbItems; index as i" class="breadcrumb-item"
    [ngClass]="i == breadcrumbItems.length - 1 ? 'active' : ''">
    <div class="w-100 d-flex" *ngIf="i == 0">
      <h2 class="uppercase w-100"><i class="material-icons-outlined">{{icon}}</i> {{ item.title | localize }} </h2>
    </div>
    <a *ngIf="i != 0" href="#" [routerLink]="[item.link]">
      {{ item.title | localize }}
    </a>
  </div>
</nav>